// ErrorContext.js
import React, { createContext, useContext, useState } from 'react'
import ConfirmationModal from '../commons/components/ConfirmationModal'
import { analyticsEvent, EVENT_KEYS } from '../commons/AnalyticsUtils'
import Colors from '../commons/Colors'
import { Redirect, useLocation } from 'react-router-dom'

const ErrorContext = createContext()

export const useErrorContext = () => {
    const context = useContext(ErrorContext)
    if (!context) {
        throw new Error('useErrorContext must be used within an ErrorProvider')
    }
    return context
}

export const ErrorProvider = ({ children }) => {
    const [errorMessage, setErrorMessage] = useState(null)
    const location = useLocation()

    const showError = message => {
        setErrorMessage(message)
    }

    const clearError = () => {
        setErrorMessage(null)
    }

    const onLogout = () => {
        analyticsEvent(EVENT_KEYS.logout)
        localStorage.removeItem('userToken')
        clearError()
        return (
            <Redirect
                to={{
                    pathname: '/login',
                    state: { from: location },
                }}
            />
        )
    }

    return (
        <ErrorContext.Provider value={{ showError, clearError }}>
            {children}
            {errorMessage && (
                <ConfirmationModal
                    buttonColorStyle={Colors.orange}
                    confirmButtonText={'SAIR'}
                    footerAlignment={'center'}
                    isCancelButtonVisible={false}
                    isLoading={false}
                    isVisible={errorMessage}
                    renderMessage={errorMessage}
                    title={'Fábrica bloqueada'}
                    onConfirm={() => onLogout()}
                    onClose={() => onLogout()}
                />
            )}
        </ErrorContext.Provider>
    )
}
